export enum Color {
  White = "#FFFFFF",
  Black = "#000000",
  Orange1 = "#6C330B",
  Orange2 = "#8E3B10",
  Orange3 = "#AB4213",
  Orange4 = "#CC4718",
  Orange5 = "#F34C1E",
  Orange6 = "#FC9E33",
  Orange7 = "#FAB65E",
  Orange8 = "#F5BB90",
  Orange9 = "#fcd6b8",
  Blue1 = "#143A5B",
  Blue2 = "#17456E",
  Blue3 = "#184F81",
  Blue4 = "#1B5993",
  Blue5 = "#0c78d9",
  Blue6 = "#4D81B2",
  Blue7 = "#759EC2",
  Blue8 = "#9EBDD3",
  Blue9 = "#D4EBEF",
  Blue10 = "#eef5f9",
  Grey1 = "#333333",
  Grey2 = "#61666A",
  Grey3 = "#727A7D",
  Grey4 = "#898F95",
  Grey5 = "#AAACAE",
  Grey6 = "#BDC1C4",
  Grey7 = "#D3D6D8",
  Grey8 = "#E6E6E6",
  Grey9 = "#F2F2F2",
  Red1 = "#6A0809",
  Red2 = "#B50505",
  Red3 = "#D90000",
  Red4 = "#F38568",
  Red5 = "#FFCDC0",
  Yellow1 = "#C7A115",
  Yellow2 = "#E4B812",
  Yellow3 = "#FFCC00",
  Yellow4 = "#F9E373",
  Yellow5 = "#F7F8D4",
  Green1 = "#194914",
  Green2 = "#287921",
  Green3 = "#36A12B",
  Green4 = "#7EC764",
  Green5 = "#E8F6E0",
  Beige = "#f6efe8",
  StripePurple = "#5B63FF",
  WhiteShadow = "rgba(255,255,255,0.3)",
  BlackShadow = "rgba(0,0,0,0.2)",
  BlackShadow1 = "rgba(0,0,0,0.16)",
  BlackShadow2 = "rgba(0,0,0,0.7)",
  OrangeShadow = "rgba(243, 76, 30, 0.3)",
  OrangeShadow1 = "rgba(243, 76, 30, 0.5)",
  OrangeShadow2 = "rgba(243, 76, 30, 0.7)",
}
